<template>
  <ion-row class="ion-no-padding ion-justify-content-start ion-align-items-center">
    <span class="text-color-placeholder pr-xs">{{ t('global.from') }}</span>
    <h3 class="h3 text-weight-bold primary" v-if="property">
      {{ amountMask(property?.amountFrom as number, property?.currency as string) }}
    </h3>
  </ion-row>
</template>

<script setup lang="ts">
  import { IonRow } from '@ionic/vue';
  import { Property } from '@/interfaces/elastic/elastic.interface';
  import { useI18n } from 'vue-i18n';
  import { amountMask } from '@/utils/validations/formats';

  const { t } = useI18n();

  withDefaults(
    defineProps<{
      property: Property | undefined;
    }>(),
    {},
  );
</script>

<style lang="css" scoped></style>
